import React from 'react';
import { Dialog } from '@headlessui/react';

export default function Modal({ isOpen, onClose, children, size = "default" }) {
  const sizeClasses = {
    default: "max-w-2xl",
    large: "max-w-4xl",
    xlarge: "max-w-6xl", // 50% wider than max-w-4xl
    full: "max-w-full mx-4"
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="relative z-50"
    >
      {/* The backdrop, rendered as a fixed sibling to the panel container */}
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className={`${sizeClasses[size]} w-full rounded-lg bg-dark-200 p-6`} onMouseDown={(e) => e.stopPropagation()}>
          {children}
        </Dialog.Panel>
      </div>
    </Dialog>
  );
} 